import React from 'react';

import Table from '../Parts/Table';
import { NewFabricSampleForm } from './NewOptionFields/ShadeActions/NewFabricSampleForm';
import PartsTable from './PartsTable';

export default class InvoiceTableComponent extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			selectedShades: [],
			QuoteNew: props.QuoteNew,
		};

		let { selectedShades } = this.state;
		
		const self = this;

		const hooks = {
			shadeSelected: (sequenceId) => {
				selectedShades.push(sequenceId);

				this.setState({
					selectedShades,
				});
			},
			shadeDeselected: (sequenceId) => {
				selectedShades = selectedShades.filter((s) => s !== sequenceId);
				this.setState({
					selectedShades,
				});
			},
			selectedShades: () => (self.state.selectedShades),
			selectAll: (ids) => {
				this.setState({
					selectedShades: ids,
				});
			},
			deselectAll: () => {
				this.setState({
					selectedShades: [],
				});
			},
		};

		this.onDone = this.onDone.bind(this);
		this.reRender = this.reRender.bind(this);

		props.QuoteNew.setHooks(hooks);
		props.QuoteNew.setRender(this.reRender);
	}

	onDone() {
		const { QuoteNew } = this.state;
		this.setState({ QuoteNew });
		this.forceUpdate();
	}

	reRender() {
		this.forceUpdate();
	}

	render() {
		const { props } = this;

		/* eslint-disable object-curly-newline */
		const INSIDE_COLUMNS = [
			{ varName: 'room_name', label: 'Room Name', hideable: true },
			{ varName: 'shade_name', label: 'Shade Name' },
			{ varName: 'direction_facing', label: 'Shade Type', hideable: true },
			{ varName: 'fabric_name', label: 'Inside Fabric', hideable: true },
			{ varName: 'fabric2_name', label: 'Outside Fabric', hideable: true },
			{ varName: 'width', label: 'Width', hideable: true },
			{ varName: 'height', label: 'Height', hideable: true },
		];

		const OUTSIDE_COLUMNS = [
			{ varName: 'room_name', label: 'Room Name', hideable: true },
			{ varName: 'shade_name', label: 'Shade Name' },
			{ varName: 'direction_facing', label: 'Direction', hideable: true },
			{ varName: 'fabric_name', label: 'Fabric', hideable: true },
			{ varName: 'side_channels', label: 'Side Channels', hideable: true },
			{ varName: 'width', label: 'Width', hideable: true },
			{ varName: 'height', label: 'Height', hideable: true },
		];
		/* eslint-enable object-curly-newline */

		const pricingAs = 'MSRP';
		const isManufacturer = false;
		const isPsAdmin = true;

		if (!isManufacturer) {
			INSIDE_COLUMNS.push({ varName: 'msrp', label: pricingAs });
			if (isPsAdmin) {
				INSIDE_COLUMNS.push({ varName: 'shipping_price', label: 'Shipping' });
			}
			OUTSIDE_COLUMNS.push({ varName: 'msrp', label: pricingAs });
		}

		const { QuoteNew } = this.state;

		const INDOOR_SHADE_ROWS = QuoteNew.ready
			? QuoteNew.shadeRows()
			: null;

		const IndoorEditRow = QuoteNew.IndoorEditRow();
		const OutdoorEditRow = QuoteNew.OutdoorEditRow();

		const accessoryTable = QuoteNew.ready
			? QuoteNew.AccessoryTable()
			: null;

		const outdoorTable = QuoteNew.ready
			? QuoteNew.OutdoorShadesTable()
			: null;

		const indoorTable = QuoteNew.ready
			? QuoteNew.IndoorShadesTable()
			: null;

		const samples = QuoteNew.quoteSamples();

		return (
			<>
				<div
					className="quote-table"
					style={{
						overflowX: 'auto',
						marginBottom: '0.25em'
					}}
				>
					<Table
						noTBody
						style={{
							width: '100%', zIndex: '22', marginBottom: '0.5em'
						}}
						quoteType={QuoteNew.QuoteType}
					>
						{INDOOR_SHADE_ROWS.length > 0 && QuoteNew.editable
							? IndoorEditRow
							: null}
					</Table>
					<Table
						quoteType={QuoteNew.QuoteType}
						noTBody
						style={{ width: '100%', zIndex: '23' }}
					>
						{indoorTable}
					</Table>
				</div>
				<br />
				<div
					className="quote-table"
					style={{
						overflowX: 'auto', overflowY: 'hidden', marginBottom: '0.25em'
					}}
				>
					<Table
						quoteType={QuoteNew.QuoteType}
						noTBody
						style={{
							width: '100%', zIndex: '22', marginBottom: '0.5em'
						}}
					>
						{outdoorTable
						&& QuoteNew.editable
						&& QuoteNew.QuoteSubstitution.hasOutdoorShades()
							? OutdoorEditRow
							: null}
					</Table>
					<Table quoteType={QuoteNew.QuoteType} noTBody style={{ width: '100%', zIndex: '22' }}>
						{outdoorTable}
					</Table>
				</div>
				<br />
				<div
					className="quote-table"
					style={{
						overflowX: 'auto', overflowY: 'hidden', marginBottom: '0.25em'
					}}
				>
					<Table quoteType={QuoteNew.QuoteType} noTBody style={{ width: '100%', zIndex: '21' }}>
						{accessoryTable}
					</Table>
				</div>
				<br />
				<div
					className="quote-table"
					style={{
						overflowX: 'auto', overflowY: 'hidden', marginBottom: '0.25em'
					}}
				>
					<Table
						quoteType={QuoteNew.QuoteType}
						className="fabric-samples"
						noTBody
						style={{ width: '100%', zIndex: '20' }}
					>
						<NewFabricSampleForm
							key={
								`fabric-${(samples ?? []).reduce((sum, next) => sum + next.quantity, 0)}`
							}
							quoteType={props.QuoteNew.QuoteType}
							quoteSamples={samples}
							onChange={QuoteNew.Data.changeFabricSampleQuantity}
							editable={QuoteNew.editable}
						/>
					</Table>
				</div>
				<br />
				<div
					className="quote-table"
					style={{
						overflowX: 'auto', overflowY: 'hidden', marginBottom: '0.25em'
					}}
				>
					<Table noTBody style={{ width: '100%', zIndex: '19' }}>
						<PartsTable
							noTBody
							key="hw_request"
							hwRequestItems={QuoteNew.hwRequestItems()}
							add={QuoteNew.addHWItem}
							deleteItem={QuoteNew.deleteHWItem}
							update={QuoteNew.updateHWItem}
							quoteType={QuoteNew.QuoteType}
							isEditable={QuoteNew.editable}
						/>
					</Table>
				</div>

				{/* {props.priceBreakDownShade ? (
					<ShadeCostBreakdown
						quote={props.quote}
						shade={priceBreakDownShade}
						onClose={() => setPriceBreakdownShade(null)}
					/>
				) : null} */}
			</>
		);
	}
}
